var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrief(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "brief",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M21,7a4.012,4.012,0,0,0-4-4H16a.945.945,0,0,0-1,1,.945.945,0,0,0,1,1h1a2.006,2.006,0,0,1,2,2V8.1a1,1,0,0,0,2,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M21,16a1,1,0,0,0-2,0v1a2.006,2.006,0,0,1-2,2H16a1,1,0,0,0,0,2h1a4.012,4.012,0,0,0,4-4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M3,17a4.012,4.012,0,0,0,4,4H8a1,1,0,0,0,0-2H7a2.006,2.006,0,0,1-2-2V16a.945.945,0,0,0-1-1,.945.945,0,0,0-1,1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M8,3H7A4.012,4.012,0,0,0,3,7V8A.945.945,0,0,0,4,9,.945.945,0,0,0,5,8V7A2.006,2.006,0,0,1,7,5H8A.945.945,0,0,0,9,4,.945.945,0,0,0,8,3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M15,9A3,3,0,0,0,9,9a3,3,0,0,0,6,0Zm-3,1a.945.945,0,0,1-1-1,1,1,0,0,1,2,0A.945.945,0,0,1,12,10Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M7.5,14.4l-.4,1.3a1.012,1.012,0,1,0,1.9.7L9.4,15a1.5,1.5,0,0,1,1.4-1h2.4a1.5,1.5,0,0,1,1.4,1l.4,1.3a.961.961,0,0,0,.9.7.367.367,0,0,0,.3-.1,1,1,0,0,0,.6-1.3l-.4-1.3A3.366,3.366,0,0,0,13.2,12H10.8A3.549,3.549,0,0,0,7.5,14.4Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrief);
export default __webpack_public_path__ + "static/media/brief.2ccaa8eb23bf32b9ecaa0675cf7aef78.svg";
export { ForwardRef as ReactComponent };